<template>
  <NavItem :item="item" :custom-click-fn="openModal" />
</template>

<script>
import NavItem from '@/modules/core/nav/components/NavItem.vue';
import { NavItem as NavItemClass } from '/@/modules/core/nav/models/NavItem';
import ModalService from '@/modules/core/ui/services/ModalService';
import GiveFeedbackModal from '@/modules/admin/components/presentational/GiveFeedbackModal.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'GiveFeedbackNavItem',
  components: { NavItem },
  props: {
    item: {
      type: NavItemClass,
      required: true
    }
  },
  methods: {
    openModal() {
      ModalService.show({
        parent: this,
        component: GiveFeedbackModal
      });
    }
  }
};
</script>
